import { render } from "./search_details.vue?vue&type=template&id=931bb474"
import script from "./search_details.vue?vue&type=script&lang=js"
export * from "./search_details.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vue\\alive-again\\sams-alive-again\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__